
<script>
    import {mapState} from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "SubscriptionPurchaseComponent",
        mixins: [AnimationsMixin],
        data () {
            return {
                componentType: "subscription-purchase",
                rendersWithVue: true
            }
        },
        computed : {
            ...mapState('products',[
                'subscriptions'
            ]),
            configData () {
                return {};
            },
            getDefaultDataStructure () {
                // console.log('**** Getting getDefaultTemplate: ', this.getDefaultTemplate, this.componentId);

                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: this.getDefaultTemplate,
                    styles: null,
                    itemVisibilitySettings: null
                }
            },
            availableSubscriptionPurchaseTemplates () {
                return [
                    {
                        templateFilename : "SubscriptionPurchaseLayout1",
                        forSectionTemplates: [
                            "tpl-subscription-contents-1",
                            "tpl-subscription-contents-2",
                        ],
                    },
                    {
                        templateFilename : "SubscriptionPurchaseLayout2",
                        forSectionTemplates: [],
                    },
                ];
            },
            getDefaultTemplate () {
                let defaultTemplate = this.availableSubscriptionPurchaseTemplates[0] ? this.availableSubscriptionPurchaseTemplates[0].templateFilename : "";
                let sectionState = this.findNodeState(this.sectionId);

                if (!sectionState) {
                    return defaultTemplate;
                }

                let sectionTemplateId = sectionState ? sectionState.sectionTemplateId : "";

                let template = this.availableSubscriptionPurchaseTemplates.find(template => template.forSectionTemplates.includes(sectionTemplateId));

                if (sectionState && template) {
                    return template.templateFilename;
                }

                return defaultTemplate
            },
            selectedSubscriptionId () {
                if (this.componentData.selectedSubscriptionId) {
                    return this.componentData.selectedSubscriptionId;
                }

                if (this.hasContext('subscription-overview-section')) {
                    const sectionNodeState = this.findNodeState(this.sectionId);
                    return sectionNodeState ? sectionNodeState.getSelectedSubscription() : "";
                }

                if (this.isPageContext('subscription') && this.pageContext.params && this.subscriptions.filter( subscription => subscription.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            mySubscriptionData () {
                let subscriptionFound = {};

                this.subscriptions.map(subscription => {
                    if (subscription.titleId === this.selectedSubscriptionId) {
                        subscriptionFound = subscription;
                    }
                })

                return subscriptionFound;
            },
            selectedLayout () {
                // console.log("selectedLayout: " , this.componentData.template)
                return this.componentData.template;
            },
            canBeCopied() {
                return false;
            },
            allowsSectionToBeCopied() {
                return false;
            }
        }
    }
</script>

